import { fromJS } from 'immutable';
export var SET_DRIVER_LIST = 'logistic-driver/SET_DRIVER_LIST';
export var SET_DRIVER_SORT = 'logistic-driver/SET_DRIVER_SORT';
export var SET_VEHICLE_LIST = 'logistic-driver/SET_VEHICLE_LIST';
export var SET_VEHICLE_SORT = 'logistic-driver/SET_VEHICLE_SORT';
export var RESET = 'logistic-driver/RESET';
export var setDriverList = function setDriverList(data) {
  return {
    type: SET_DRIVER_LIST,
    data: data
  };
};
export var setDriverSort = function setDriverSort(sort) {
  return {
    type: SET_DRIVER_SORT,
    sort: sort
  };
};
export var setVehicleList = function setVehicleList(data) {
  return {
    type: SET_VEHICLE_LIST,
    data: data
  };
};
export var setVehicleSort = function setVehicleSort(sort) {
  return {
    type: SET_VEHICLE_SORT,
    sort: sort
  };
};
export var reset = function reset() {
  return {
    type: RESET
  };
};
var initialState = fromJS({
  driverList: [],
  driverSort: {
    field: 'modifiedAt',
    desc: true
  },
  vehicleList: [],
  vehicleSort: {
    field: 'modifiedAt',
    desc: true
  }
});
export default function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case SET_DRIVER_LIST:
      return state.set('driverList', fromJS(action.data));

    case SET_DRIVER_SORT:
      return state.set('driverSort', fromJS(action.sort));

    case SET_VEHICLE_LIST:
      return state.set('vehicleList', fromJS(action.data));

    case SET_VEHICLE_SORT:
      return state.set('vehicleSort', fromJS(action.sort));

    case RESET:
      return initialState;

    default:
      return state;
  }
}